<script type="text/javascript">
    export default {
        data() {
            return {
                switchery_elem: null
            }
        },

        watch: {
            value : function (value) {
                if (this.switchery_elem) {
                    this.setSwitchery(this.switchery_elem, this.value);
                }
            },

            editable: function (value) {
                if (value && this.switchery_elem) {
                    this.switchery_elem.enable();
                } else {
                    this.switchery_elem.disable();
                }
            }
        },

        props: {
            editable: {
                default: 1
            },

            invert: {
                default: false
            },

            name: {
                default: ''
            },

            text: {
                default : ''
            },

            value: {
                required: true
            },
            light: {
                default: false
            },
            activeColor: {
                default: 'var(--primary-color)'
            }
        },

        mounted() {
            $(document).ready(async () => {
                await this.$nextTick();
                this.buildSwitchery();
            });
        },

        methods: {
            buildSwitchery() {
                var elem = this.$refs.switheryInput;

                let secondaryColor = '#eee';

                if( $(this.$refs.switheryInput).parents().hasClass('inverted-bg')) {
                   secondaryColor = '#fff';
                }

                this.switchery_elem = new Switchery(elem, { color: this.activeColor, secondaryColor: secondaryColor, size: 'small' });

                elem.onchange = () => {
                    if (elem.checked) {
                        this.changeValue(1);
                    } else {
                        this.changeValue(0);
                    }
                };
            },

            changeValue(checked) {
                this.$emit('input', checked);
            },

            toggleSwitch() {
                if (!this.editable) return;
                this.$emit('input', !this.value);
            },

            setSwitchery(switchElement, checkedBool) {
                if ((checkedBool && !switchElement.isChecked()) || (!checkedBool && switchElement.isChecked())) {
                    switchElement.setPosition(true);
                    switchElement.handleOnchange(true);
                }
            },
        }
    };
</script>

<template id="switchery">
    <div class="switch-group form-group align-center">
        <div class="switch-wrapper m-r-10" :class="{'light': light}" @click="$emit('clicked')">
            <input :id="name" type="checkbox" ref="switheryInput" :name="name" @input="changeValue" :checked="value" :disabled="!editable">
        </div>
        <slot name="icon"></slot>
        <label :for="name" class="help-block m-0 font-normal cursor-pointer" v-if="text" @click.prevent="toggleSwitch">
            {{ text }}
        </label>
        <p class="help-block m-0 cursor-pointer" v-if="!text" @click.prevent="toggleSwitch">
            <slot></slot>
        </p>
    </div>
</template>

<style scoped>
.help-block {
    color: var(--n-text-color-weaker);
}
</style>
